homeFaqs = {
    init: function () {
        $(".faqs-item").on("click", function () {
            var item = $(this);

            if (!item.hasClass("open")) {
                // OPEN
                item.addClass("open");
                item.find(".faqs-item__body").height(item.find(".faqs-item__body--inner").outerHeight());
            } else {
                // CLOSE
                item.removeClass("open");
                item.find(".faqs-item__body").height(0);
            }
        });
    }
};

$(document).ready(function () {
    homeFaqs.init();
});